import FindClosest from './find-closest';

const FIELD_CONTAINER_ACTIVE_CLASS = 'gfield--active'
const FIELD_CONTAINER_FILLED_CLASS = 'gfield--filled'
const PARENT_ELEMENT_BASE_CLASS = 'gfield'

class GformField {
  constructor(field) {
    this.field = field
    this.parentElement = FindClosest(PARENT_ELEMENT_BASE_CLASS, this.field);

    this.field.addEventListener('focus', this.focusHandler.bind(this))
    this.field.addEventListener('blur', this.blurHandler.bind(this))
    this.field.addEventListener('input', this.inputHandler.bind(this));

    if (!! this.field.value) {
      this.event = new Event('input')
      this.field.dispatchEvent(this.event)
    }

  }

  focusHandler(e) {
    this.parentElement.classList.add(FIELD_CONTAINER_ACTIVE_CLASS)
  }

  blurHandler(e) {
    this.parentElement.classList.remove(FIELD_CONTAINER_ACTIVE_CLASS)
  }

  inputHandler(e) {
    let value = this.field.value
    let action = value.length ? 'add' : 'remove'

    if (this.field.tagName.toLowerCase() === 'textarea') {
      this.field.style.height = 'auto';
      this.field.style.height = `${this.field.scrollHeight}px`;
    }

    return this.parentElement.classList[action](FIELD_CONTAINER_FILLED_CLASS)
  }

  getParentElement(element) {
    let el = element

    // Get each parent element and check for a .gfield class - (!) causes it
    // to continue looping until we find the parent .gfield element. Then,
    // we return the current `el` parentElement.
    while ((el = el.parentElement) && ! el.classList.contains(PARENT_ELEMENT_BASE_CLASS))

    return el.parentElement
  }
}

function init() {
  let fields = document.querySelectorAll('.gfield input, .gfield textarea')

  fields = [].slice.call(fields)

  fields.forEach((field) => new GformField(field))
}

document.addEventListener('DOMContentLoaded', init.bind(this))
document.addEventListener('turbolinks:load', init.bind(this))



/** WEBPACK FOOTER **
 ** ./assets/js/lib/form.js
 **/